import { AppBanner } from '@/components/app-banner'
import { LoadingMessage } from '@/components/loading-message'
import { ErrorMessage } from '@/components/error-message'
import { useOrgRedirect } from '@/hooks/useOrgRedirect'
import { useUserStore } from '@/store/UserStore'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/')({
  component: Index,
})

function Index() {
  const user = useUserStore((state) => state.user)
  const navigate = useNavigate()

  const { mutate, isPending, isError, error } = useOrgRedirect()

  useEffect(() => {
    if (user) {
      mutate()
    } else {
      navigate({ to: '/login' })
    }
  }, [user, mutate, navigate])

  return (
    <>
      <AppBanner />

      <div className="flex items-center justify-center h-screen">
        {isPending && <LoadingMessage message="Loading..." centered />}
        {isError && (
          <ErrorMessage message={error?.message || 'An error occurred'} />
        )}
      </div>
    </>
  )
}

export default Index
